(() => {
  if (window.__shopifyInboxTriggers) return;
  window.__shopifyInboxTriggers = true;
  let retryTimer;
  const findLauncher = (root) => {
    if (!root) return null;
    const launcher = root.querySelector('button[aria-label="Chat"], button.activator');
    if (launcher) return launcher;
    for (const element of root.querySelectorAll('*')) {
      if (!element.shadowRoot) continue;
      const nestedLauncher = findLauncher(element.shadowRoot);
      if (nestedLauncher) return nestedLauncher;
    }
    return null;
  };
  const openInbox = (attempt = 0) => {
    const host = document.querySelector('shopify-chat');
    if (host && typeof host.show === 'function') {
      window.queueMicrotask(() => host.show());
      return;
    }
    const button = findLauncher(host && host.shadowRoot);
    if (button) {
      if (button.getAttribute('aria-expanded') !== 'true') window.queueMicrotask(() => button.click());
      return;
    }
    if (attempt < 40) retryTimer = window.setTimeout(() => openInbox(attempt + 1), 125);
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-shopify-inbox-trigger]');
    if (!trigger) return;
    event.preventDefault();
    window.clearTimeout(retryTimer);
    openInbox();
  });
})();
